import { WithStyles, withStyles } from '@mui/styles';
import { RouteComponentProps } from 'react-router-dom';

import { ApiConnectionDetails } from './apiConnectionDetails';
import { muiStyles } from './apiConnectionDetailsStyles';

type RouteParams = {
    apiConnectionId: string;
};

export interface ApiConnectionDetailsProps extends RouteComponentProps<RouteParams>, WithStyles<typeof muiStyles>{
    editApiConnection: () => void;
}

export default withStyles(muiStyles)(ApiConnectionDetails);